import styles from './styles.module.sass';
import cn from 'classnames';
import { DetailedHTMLProps, HtmlHTMLAttributes } from 'react';
import { pxToRem } from '@intigral/utils/lib/helpers/pxToRem';
import withResponsiveStyles, { ResponsiveValue } from '../hocs/ResponiseStyles/withResponsiveStyles';

export interface SeparatorProps extends DetailedHTMLProps<HtmlHTMLAttributes<HTMLHRElement>, HTMLHRElement> {
    orientation?: 'vertical' | 'horizontal';
    color?: 'dark' | 'light' | 'white';
    marginBottom?: ResponsiveValue;
    heightValue?: number;
    text?: string;
}

export const OriginalSeparator = ({
    orientation = 'horizontal',
    color = 'light',
    marginBottom,
    heightValue,
    text,
    className,
    ...props
}: SeparatorProps) => {
    const classNames = cn(styles.hr, styles[`${color}`], className);

    const rem = heightValue && pxToRem(heightValue);

    // return <hr className={classNames} aria-orientation={orientation} style={{ height: rem }} {...props} />;
    return text ? (
        <div className={cn(styles.holder, styles.texted)}>
            <hr className={classNames} aria-orientation={orientation} style={{ height: rem }} {...props} />
            <span>{text}</span>
        </div>
    ) : (
        <hr className={classNames} aria-orientation={orientation} style={{ height: rem }} {...props} />
    );
};

export const Separator = withResponsiveStyles(OriginalSeparator);
